import {Injectable, OnDestroy} from "@angular/core";
import {ReplaySubject} from "rxjs";

/*
* usage
* Provide service in component/directive
* in pipe use takeUntil(service instance)
* */

@Injectable()
export class DestroyStreamService extends ReplaySubject<any> implements OnDestroy {
  constructor() {
    super(1);
  }
  ngOnDestroy() {
    this.next();
    this.complete();
  }
}
